import type { FC } from 'react';
import {
  FilterProvider,
  FormProvider,
  PaginationProvider,
  SearchProvider,
  SortProvider,
} from 'dash-ui';

import PropertiesDataProvider from 'common/contexts/PropertiesData/PropertiesDataProvider';
import CMSPropertiesTable from './components/CMSPropertiesTable/CMSPropertiesTable';

import type { PropertiesProps } from './Properties.interfaces';
import { FormFieldsList } from './constants/constants';

const Properties: FC<PropertiesProps> = ({
  tableProps,
  filter,
  storageTableName,
}) => {
  return (
    <PaginationProvider storageTableName={storageTableName}>
      <SortProvider>
        <SearchProvider>
          <FilterProvider>
            <FormProvider fieldsList={FormFieldsList}>
              <PropertiesDataProvider filter={filter}>
                <CMSPropertiesTable {...tableProps} />
              </PropertiesDataProvider>
            </FormProvider>
          </FilterProvider>
        </SearchProvider>
      </SortProvider>
    </PaginationProvider>
  );
};

export default Properties;
